import { css } from 'aphrodite';
import * as React from 'react';
import { styleSheet } from './styles';

interface IProps {
	message?: string;
}

export const LoadingSpinner: React.FC<IProps> = ({ message = 'Loading...' }) => {
	return (
		<div className={css(styleSheet.container)}>
			<div className={css(styleSheet.spinner)} />
			<p className={css(styleSheet.message)}>{message}</p>
		</div>
	);
};
